import _ from 'underscore'
import { utils } from '../plugins/utils'


const mutations = {
  /**
   * ステートの内容を更新する
   * @param {{[key:string]:any}} state      現在のステート
   * @param {{[key:string]:any}} payload    引数オブジェクト。アップデートするべき内容
   */
  update (state, payload) {
    _.each(payload, (_val, _key) => {
      // 値をアップデートするのはステートに既存のプロパティ名のときのみ。
      if (_.has(state, _key)) state[_key] = _val
    })
  },

  /**
   * ステートをまっさらな状態へ戻す
   * @param {{[key:string]:any}}   state                現在のステート
   * @param {{[key:string]:any}}   payload              引数オブジェクト。メンバーは以下のもの
   * @param {string[]}             [payload.targets]     - リセット対象のプロパティ名を並べた配列。無指定時は当該 Store まるごとのリセット
   * @param {string[]}             [payload.excepts]     - リセット対象から除外するプロパティ名を並べた配列。
   * @param {{[key:string]:any}}   [payload.origin]      - リセットによって戻ったときの姿 (オリジナルのステート内容)
   */
  reset (state, { targets, excepts, origin }) {
    targets = _.toArray(targets)
    excepts = _.toArray(excepts)

    origin = origin || {}
    origin = targets.length ? _.pick(origin, targets) : origin  // リセット対象のプロパティのみ残す
    origin = _.omit(origin, excepts)                            // リセット対象から除外するプロパティを除外

    mutations.update(state, origin)
  },
}

export default { mutations, ...utils }
